module.exports = __webpack_public_path__ + "static/img/A6408_.9a13352e.png";